import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {User} from '../../Interfaces/User';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {QueryService} from '../../Services/query.service';
import {AppComponent} from '../../app.component';
import {CountdownComponent, CountdownEvent} from 'ngx-countdown';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {SharedVarService} from '../shared-service.service';

@Component({
  selector: 'app-enter-passcode',
  templateUrl: './enter-passcode.component.html',
  styleUrls: ['./enter-passcode.component.css']
})
export class EnterPasscodeComponent implements OnInit, AfterViewInit {
  myForm: UntypedFormGroup;
  myForm2: UntypedFormGroup;

  submitted: boolean = false;
  submitted2: boolean = false;
  goodCode: boolean = false;
  userNotFound: boolean = false;
  formatError: boolean = false;
  emailNotFound: boolean = false;
  resetVerifyExpired: boolean = false;
  navisErrors: string = " ";
  maherError: string ;
  maxRetry: boolean = false;
  clientRequest: ClientRequest;
  myUser = {} as User;
  subscription: Subscription;
  disableFields: boolean = true;
  numberFound: number = 0;
  upperFound: number = 0;
  lowerFound: number = 0;
  totalFound: number = 0;
  strangeFound: number = 0;
  activePass: boolean = true;
  activeConfirm: boolean = true;


  badPassword: boolean = true;
  @ViewChild("confirmCode") userField: ElementRef;
  @ViewChild('myTimer') private countdown: CountdownComponent;

  constructor(fb: UntypedFormBuilder,  private router: Router, private  queryService: QueryService, public myApp:AppComponent, private  globalEventsManager: GlobalEventsManager,  private service: SharedVarService) {
    this.service.getUsername().subscribe((value) => {
        this.myUser.username = value;
    });

    this.myForm = fb.group({
        code:  ['',   [Validators.pattern( '^[0-9]*$'), Validators.required]]
    });

    this.myForm2 = fb.group({
        password:   [{value: '', disabled: this.disableFields}, [Validators.required]],
        confirm:  [{value: '', disabled: this.disableFields}, [Validators.required]]},
      {validator: MustMatch('password','confirm')
      });


  }

  get f() { return this.myForm.controls;}
  get g() { return this.myForm2.controls;}

  ngOnInit() {

  }

  ngAfterViewInit(): void {
    this.myForm2.controls['password'].disable();
    this.myForm2.controls['confirm'].disable();
    setTimeout(() => this.userField.nativeElement.focus());

  }


  bustOut(e: CountdownEvent){
    if (e.action=="done"){
      console.log("Finished");
      this.router.navigate([""]);
    }
  }



   isValid(str){
    return !/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(str);
  }


  resetPassword(){
    this.submitted2 = true;
    this.userNotFound = false;
    this.emailNotFound = false;
    this.resetVerifyExpired = false;
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.requestData = [];
    this.clientRequest.user = this.myUser;
    if (this.myForm2.valid) {
      this.myUser.password = this.myForm2.controls["password"].value;
      const lhsUserObs$ = this.queryService.updatePassword(this.clientRequest);
      this.subscription = lhsUserObs$.subscribe(
        (lhsUser) => {
          this.myUser = lhsUser;
        },
        error => {
          if (error.status == "401") {
            this.globalEventsManager.showLogin.emit(true);

            this.router.navigate(["login"]);
          } else {
            this.myApp.openDialog(error.message)
          }
        },
        () => {
          this.maherError = null;

          if (this.myUser.maherError != null) {
             this.maherError = this.myUser.maherError;
          }else if (this.myUser.navisErrors!=null){
            if (this.myUser.navisErrors.length > 0) {
              for (var xx of this.myUser.navisErrors) {
                this.navisErrors = this.navisErrors + xx.valueOf();
              }
            }
          }else{
            this.myApp.showSuccessBanner("","your password has been changed successfully","login");
          }
        });
    }
  }

  showConfirmPassword(){
    if (this.activeConfirm){
      this.activeConfirm = false;
    }else{
     this.activeConfirm = true;
    }
  }


  showPassword(){
    if (this.activePass){
      this.activePass = false;
    }else{
      this.activePass = true;
    }
  }

  validateResetPassword(){
    this.disableFields = true;
    this.submitted = true;
    this.goodCode = false;
    this.userNotFound = false;
    this.emailNotFound = false;
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.requestData = [];
    this.clientRequest.user = this.myUser;
    if (this.myForm.valid) {
      const lhsUserObs$ = this.queryService.validateResetPassword(this.clientRequest);
      this.subscription = lhsUserObs$.subscribe(
        (lhsUser) => {
          this.myUser = lhsUser;
        },
        error => {
          if (error.status == "401") {
            this.globalEventsManager.showLogin.emit(true);

            this.router.navigate(["login"]);
          } else {
            this.myApp.openDialog(error.message)
          }
        },
        () => {
          this.maherError = null;

          if (this.myUser.maherError != null && this.myUser.maherError!="") {
             this.maherError = this.myUser.maherError;
          }else{
            this.disableFields = false;
            this.goodCode=true;
            this.countdown.stop();
            this.submitted = false;
            this.myForm.controls['code'].disable();
            this.myForm2.controls['password'].enable();
            this.myForm2.controls["password"].setValue("");

            this.myForm2.controls['confirm'].enable();
            this.myForm2.controls["confirm"].setValue("");


          }
        });
    }
  }
  checkRules(){
    var character='';
    var i=0;

    this.totalFound = 0;
    this.lowerFound = 0;
    this.numberFound = 0;
    this.strangeFound = 0;

    var format = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
    while (i <= this.myForm2.controls["password"].value.length){
      character = this.myForm2.controls["password"].value.charAt(i);
      if (character==""){
      }else if (!isNaN(Number(character))){
        this.numberFound = this.numberFound + 1;
      }else if( character.match(format) ){
        this.strangeFound = this.strangeFound + 1;
      }else if (character == character.toLowerCase()){
        this.lowerFound = this.lowerFound + 1;
      }
      this.totalFound = this.totalFound + 1;
      i++;
    }

  }


  returnBack(){
    this.router.navigate([""]);

  }
}

// custom validator to check that two fields match
export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: UntypedFormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  }
}
